import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Shield, Mail, Phone } from 'lucide-react';
import { Card } from '../components/ui/card';

export default function PrivacyPolicyPage() {
  return (
    <div className="px-4 pt-4 space-y-4 pb-8">
      <Link to="/" className="inline-flex items-center gap-1 text-sm text-gray-600 hover:text-emerald-600 font-medium" data-testid="privacy-back">
        <ArrowLeft size={16} /> ମୁଖ୍ୟ ପେଜ କୁ ଫେରନ୍ତୁ
      </Link>

      <div className="rounded-3xl p-5 text-white shadow-lg" style={{ background: 'linear-gradient(135deg, #059669 0%, #0891b2 60%, #0f766e 100%)' }}>
        <Shield size={26} />
        <h1 className="text-xl font-extrabold mt-2">Privacy Policy · ଗୋପନୀୟତା ନୀତି</h1>
        <p className="text-xs text-white/90 mt-1">Last updated: February 2026 · Gurusevakendra</p>
      </div>

      <Card className="rounded-2xl p-5 border-gray-200 space-y-4 text-sm leading-relaxed text-gray-800">
        <section>
          <h2 className="font-bold text-base text-gray-900 mb-1">୧. ପରିଚୟ (Introduction)</h2>
          <p>Gurusevakendra ("ଆମେ", "ଆମର", "App") ଆପଣଙ୍କ ଗୋପନୀୟତାକୁ ସମ୍ମାନ ଦିଏ। ଏହି policy ଦେଖାଏ ଯେ ଆମେ ଆପଣଙ୍କ ତଥ୍ୟ କିପରି ସଂଗ୍ରହ, ବ୍ୟବହାର ଓ ସୁରକ୍ଷିତ ରଖୁ।</p>
          <p className="text-xs text-gray-500 mt-1">Gurusevakendra ("we", "us", "our") respects your privacy. This policy explains how we collect, use and protect your data.</p>
        </section>

        <section>
          <h2 className="font-bold text-base text-gray-900 mb-1">୨. ଆମେ କେଉଁ ତଥ୍ୟ ସଂଗ୍ରହ କରୁ? (Information We Collect)</h2>
          <ul className="list-disc pl-5 space-y-1">
            <li><strong>Google Login Data:</strong> ନାମ, ଇମେଲ୍, profile picture — କେବଳ App ରେ login ଓ personalization ପାଇଁ</li>
            <li><strong>Learning Data:</strong> Quiz score, chapter progress, bookmarks — ଆପଣଙ୍କ progress track କରିବା ପାଇଁ</li>
            <li><strong>Chat Messages:</strong> AI doubt solver ରେ ପଚାରିଥିବା ପ୍ରଶ୍ନ — response ଦେବା ପାଇଁ</li>
            <li><strong>Payment Info:</strong> UTR/Transaction ID — ପେମେଣ୍ଟ verification ପାଇଁ (Card/Bank details ଆମେ save କରୁ ନାହିଁ)</li>
          </ul>
        </section>

        <section>
          <h2 className="font-bold text-base text-gray-900 mb-1">୩. ତଥ୍ୟ ବ୍ୟବହାର (How We Use Your Data)</h2>
          <ul className="list-disc pl-5 space-y-1">
            <li>Notes, quiz, AI chat, certificate ପ୍ରଦାନ କରିବା</li>
            <li>Premium activate ଓ payment verify କରିବା</li>
            <li>App improvement ପାଇଁ anonymized analytics</li>
            <li>ଆବଶ୍ୟକ ସୂଚନା (push notification) ପଠାଇବା</li>
          </ul>
        </section>

        <section>
          <h2 className="font-bold text-base text-gray-900 mb-1">୪. ତଥ୍ୟ ଆଦାନ-ପ୍ରଦାନ (Data Sharing)</h2>
          <p>ଆମେ ଆପଣଙ୍କ personal ତଥ୍ୟ ତୃତୀୟ ପକ୍ଷକୁ **ବିକ୍ରୟ କରୁ ନାହିଁ**। କେବଳ ନିମ୍ନଲିଖିତ ସେବା ପାଇଁ share କରାଯାଏ:</p>
          <ul className="list-disc pl-5 space-y-1 mt-1">
            <li><strong>Google (OAuth Login):</strong> Authentication ପାଇଁ</li>
            <li><strong>OpenAI (AI Chat):</strong> ପ୍ରଶ୍ନ ର response generate କରିବା ପାଇଁ</li>
            <li><strong>Legal Requests:</strong> ଆଇନ ଅନୁସାରେ ଆବଶ୍ୟକ ହେଲେ</li>
          </ul>
        </section>

        <section>
          <h2 className="font-bold text-base text-gray-900 mb-1">୫. Data Security</h2>
          <p>ଆମେ HTTPS encryption, secure MongoDB storage, ଓ token-based session ବ୍ୟବହାର କରୁ। କିନ୍ତୁ ୧୦୦% ସୁରକ୍ଷାର ଗ୍ୟାରେଣ୍ଟି କୌଣସି internet service ଦେଇ ପାରେ ନାହିଁ।</p>
        </section>

        <section>
          <h2 className="font-bold text-base text-gray-900 mb-1">୬. ଆପଣଙ୍କ ଅଧିକାର (Your Rights)</h2>
          <ul className="list-disc pl-5 space-y-1">
            <li>Account delete କରିବାର ଅଧିକାର</li>
            <li>Data export ମାଗିବାର ଅଧିକାର</li>
            <li>Marketing message ବନ୍ଦ କରିବାର ଅଧିକାର</li>
            <li>ଭୁଲ ତଥ୍ୟ correct କରିବାର ଅଧିକାର</li>
          </ul>
          <p className="mt-1">Account delete ଚାହିଁଲେ ଇମେଲ୍ କରନ୍ତୁ: <a href="mailto:gurusevakendra33@gmail.com" className="text-emerald-700 font-semibold underline">gurusevakendra33@gmail.com</a></p>
        </section>

        <section>
          <h2 className="font-bold text-base text-gray-900 mb-1">୭. Children's Privacy (୧୩ ବର୍ଷରୁ କମ୍ ଛାତ୍ର)</h2>
          <p>Gurusevakendra ୧୩ ବର୍ଷରୁ କମ୍ ଛାତ୍ର-ଛାତ୍ରୀଙ୍କ ପାଇଁ ମାତା-ପିତାଙ୍କ ତତ୍ତ୍ୱାବଧାନରେ ବ୍ୟବହାର କରାଯିବା ଉଚିତ୍। ଆମେ ଉଦ୍ଦେଶ୍ୟପୂର୍ବକ ୧୩ ବର୍ଷରୁ କମ୍ ଛାତ୍ରଙ୍କ personal data ସଂଗ୍ରହ କରୁ ନାହିଁ।</p>
        </section>

        <section>
          <h2 className="font-bold text-base text-gray-900 mb-1">୮. Cookies ଓ Local Storage</h2>
          <p>Session ଓ preferences save କରିବା ପାଇଁ App localStorage ବ୍ୟବହାର କରେ। ଆପଣ browser settings ରୁ ଏହା ବନ୍ଦ କରିପାରିବେ (କିନ୍ତୁ login କରିପାରିବେ ନାହିଁ)।</p>
        </section>

        <section>
          <h2 className="font-bold text-base text-gray-900 mb-1">୯. Policy Update</h2>
          <p>ଏହି policy ସମୟାନୁସାରେ update ହୋଇପାରେ। ପରିବର୍ତ୍ତନ ହେଲେ ଏହି page ର date update ହେବ। ମୁଖ୍ୟ ପରିବର୍ତ୍ତନ ପାଇଁ ଆମେ notification ପଠାଇବୁ।</p>
        </section>

        <section>
          <h2 className="font-bold text-base text-gray-900 mb-1">୧୦. ଯୋଗାଯୋଗ (Contact Us)</h2>
          <div className="space-y-1.5 mt-2">
            <p className="flex items-center gap-2"><Mail size={14} className="text-emerald-600" /> <a href="mailto:gurusevakendra33@gmail.com" className="text-emerald-700 font-semibold">gurusevakendra33@gmail.com</a></p>
            <p className="flex items-center gap-2"><Phone size={14} className="text-emerald-600" /> <a href="tel:+917325893950" className="text-emerald-700 font-semibold">+91 73258 93950</a> (WhatsApp)</p>
          </div>
        </section>

        <section className="pt-3 border-t border-gray-200">
          <p className="text-[11px] text-gray-500 italic">By using Gurusevakendra, you agree to this Privacy Policy. ଆପ ବ୍ୟବହାର କରି ଆପଣ ଏହି ନୀତିରେ ସହମତ ହୁଅନ୍ତି।</p>
        </section>
      </Card>
    </div>
  );
}
